import React from 'react';
import './bannerMessage.scss';

const BannerMessage = ({title, subtitle}) => {
	return (
		<div className="banner-message__banner">
			<div className="banner-message__banner__container">
				<span className="banner-message__banner__container__title" >
					{title}
				</span>
				<span className="banner-message__banner__container__description">
					{subtitle}
				</span>
			</div>
		</div>
	);
}

export default BannerMessage;
